import { render, staticRenderFns } from "./emoji-picker-dialog.vue?vue&type=template&id=61098129&scoped=true"
import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=61098129&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61098129",
  null
  
)

export default component.exports